import { ReactNode } from "react";

import { useLoadSnackpassStores } from "#hooks/initial/use-load-snackpass-stores";
import { usePersistStoreId } from "#hooks/initial/use-persist-store-id";
import { useSyncActiveStore } from "#hooks/initial/use-sync-active-store";
import { useInvites } from "#navigation/hooks";

export const StoreScopedBootstrap = ({ children }: { children: ReactNode }) => {
    useLoadSnackpassStores();
    usePersistStoreId();
    useSyncActiveStore();
    useInvites();

    return <>{children}</>;
};
